import React from 'react'

import { TabelaColuna } from 'src/componentes'

export const colunaQuantidadeProrrogacoes = (): TabelaColuna => ({
  Chave: 'qtdProrrogacoes',
  ComOrdenacao: true,
  RenderizarCabecalho: () => (
    <div style={{ width: 100 }}>Quantidade Prorrogações</div>
  )
})
